import type { CPU } from '../CPU';
import { PSW_C, PSW_Z, PSW_S, PSW_OV, H_TI } from './constants';

export function opBC(cpu: CPU): void {
  const c = !!(cpu.impl_flags_in & PSW_C);
  const z = !!(cpu.impl_flags_in & PSW_Z);
  const s = !!(cpu.impl_flags_in & PSW_S);
  const ov = !!(cpu.impl_flags_in & PSW_OV);
  const le = z || c;
  const lts = ov !== s;
  const les = lts || z;

  let branch: boolean;
  switch ((cpu.impl_opcode >> 8) & 0x000F) {
    case 0: branch = !c; break;
    case 1: branch = c; break;
    case 2: branch = !le; break;
    case 3: branch = le; break;
    case 4: branch = !lts; break;
    case 5: branch = lts; break;
    case 6: branch = !les; break;
    case 7: branch = les; break;
    case 8: branch = !z; break;
    case 9: branch = z; break;
    case 10: branch = !ov; break;
    case 11: branch = ov; break;
    case 12: branch = !s; break;
    case 13: branch = s; break;
    default: branch = true; break;
  }

  if (branch) {
    let offset = cpu.impl_operands[0].value;
    offset |= (offset & 0x80) ? 0x7F00 : 0;
    cpu.regs.pc = (cpu.regs.pc + (offset << 1)) & 0xFFFF;
  }
}

export function opB(cpu: CPU): void {
  if (cpu.impl_hint & H_TI) {
    cpu.regs.csr = cpu.impl_operands[1].value;
    cpu.regs.pc = cpu.impl_long_imm;
  } else {
    cpu.regs.pc = cpu.impl_operands[1].value;
  }
}

export function opBL(cpu: CPU): void {
  cpu.regs.elr[0] = cpu.regs.pc;
  opB(cpu);
}

export function opRT(cpu: CPU): void {
  cpu.regs.csr = cpu.regs.ecsr[0];
  cpu.regs.pc = cpu.regs.elr[0];
}

export function opRTI(cpu: CPU): void {
  cpu.regs.csr = cpu.regs.ecsr[cpu.regs.psw & 0x03];
  cpu.regs.pc = cpu.regs.elr[cpu.regs.psw & 0x03];
  cpu.regs.psw = cpu.regs.epsw[cpu.regs.psw & 0x03];
}
